var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[(_vm.formKey === 'time_period')?_c('schedule-time',{ref:"schedule_time_ref",attrs:{"is-preview":_vm.formItem.isPreview,"is-hour":!!_vm.formItem.isHour,"preele":"step-form-scrollbar-wrapper","value":_vm.formItem.value}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }